import type { StatusDurationPreset } from './types';

export const setStatusStrings = {
  title: 'Set status',
  cancel: 'Cancel',
  clear: 'Clear status',
  commit: 'Set',
  emojiLabel: 'Emoji',
  textLabel: 'What\u2019s up?',
  textPlaceholder: 'Add a status',
  durationLabel: 'Clear after',
  customDurationLabel: 'Pick date and time',
  countdownExpired: 'Expired',
} as const;

export const durationPresetLabel: Readonly<Record<StatusDurationPreset, string>> = {
  thirtyMinutes: '30 minutes',
  oneHour: '1 hour',
  fourHours: '4 hours',
  today: 'Today',
  thisWeek: 'This week',
  custom: 'Custom',
};
